export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", icon: "ri-t-shirt-line" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", icon: "ri-t-shirt-air-line" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", icon: "ri-pantone-line" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", icon: "ri-glasses-line" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { name: "Underwear/Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", icon: "ri-user-line" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", icon: "ri-football-line" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", icon: "ri-emotion-happy-line" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", icon: "ri-shopping-bag-line" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", icon: "ri-links-line" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", icon: "ri-vip-crown-line" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", icon: "ri-more-line" },
];

export const mainSiteUrl = "https://kaspreadsheet.com";

export const featureItems = [
  {
    title: "Product Organization",
    description: "Keep all your product research neatly organized in one structured spreadsheet system. No more scattered bookmarks or lost product links.",
    icon: "ri-folder-2-line",
  },
  {
    title: "Easy Comparison",
    description: "Compare products side by side with our structured format. Make informed decisions by evaluating price, quality, and features at a glance.",
    icon: "ri-scales-line",
  },
  {
    title: "Category Filtering",
    description: "Quickly filter and sort products by category, price range, or quality tier. Find exactly what you need without endless scrolling.",
    icon: "ri-filter-3-line",
  },
  {
    title: "Research Efficiency",
    description: "Cut your product research time significantly. What used to take hours now takes minutes with our streamlined spreadsheet approach.",
    icon: "ri-timer-line",
  },
  {
    title: "Updated Information",
    description: "Access regularly updated product information and resources. Stay ahead with the latest finds and trending items in every category.",
    icon: "ri-refresh-line",
  },
  {
    title: "Better Decision Making",
    description: "Transform raw product data into actionable insights. Our spreadsheet methodology helps you choose products with confidence every time.",
    icon: "ri-lightbulb-flash-line",
  },
];

export const howItWorksSteps = [
  {
    step: "01",
    title: "Find Products",
    description: "Browse through organized categories and discover products that match your interests. Use our comprehensive spreadsheet to pinpoint exactly what you're looking for.",
  },
  {
    step: "02",
    title: "Compare Information",
    description: "Evaluate products using our side-by-side comparison framework. Review quality indicators, pricing data, and detailed product specifications.",
  },
  {
    step: "03",
    title: "Review Details",
    description: "Dive deep into product specifics, QC information, and user feedback. Make sure every detail checks out before making your decision.",
  },
  {
    step: "04",
    title: "Make Better Decisions",
    description: "With all the organized data at your fingertips, confidently choose the best products for your needs. Save money and time with smarter shopping.",
  },
];

export const safetyItems = [
  {
    risk: "Fake Websites",
    action: "Verify official sources and use trusted links",
  },
  {
    risk: "Incorrect Information",
    action: "Cross-check resources across multiple platforms",
  },
  {
    risk: "Privacy Risks",
    action: "Avoid sharing sensitive personal data online",
  },
  {
    risk: "Scam Listings",
    action: "Always verify seller reputation and reviews",
  },
];

export const comparisonData = [
  { category: "Product Discovery", traditional: "Scattered across multiple websites and forums", spreadsheet: "All products organized in one structured view" },
  { category: "Organization", traditional: "Bookmarks, notes, and memory-based tracking", spreadsheet: "Systematic categorization with easy filtering" },
  { category: "Comparison", traditional: "Manual tab-switching between product pages", spreadsheet: "Side-by-side comparison in single view" },
  { category: "Time Saving", traditional: "Hours of repetitive searching and note-taking", spreadsheet: "Streamlined research process cuts time by 70%" },
  { category: "Research Quality", traditional: "Inconsistent and fragmented information gathering", spreadsheet: "Comprehensive and methodical product evaluation" },
  { category: "Decision Making", traditional: "Overwhelmed by too many scattered options", spreadsheet: "Clear data-driven purchasing decisions" },
];